import { CircleSpinner } from "common/spinners";
import { CTA } from "common/styleguide/CTA";
import { ModalOverlay } from "common/styleguide/ModalOverlay";
import { commonCTAs, Msg } from "lib/localization";
import React from "react";

// If you need more than a Cancel/Confirm, don't use this
export const ConfirmationDialog = ({
  title,
  danger,
  children,
  onConfirm,
  confirmText,
  showCancel,
  cancelText,
  onCancel,
  onRequestClose,
  confirmPending,
  confirmDisabled,
  footerHint,
  noFooter,
  ...props
}) => (
  <ModalOverlay
    title={title}
    maxWidth="500px"
    onRequestClose={onRequestClose}
    footer={
      !noFooter && (
        <Footer
          danger={danger}
          onConfirm={onConfirm}
          confirmPending={confirmPending}
          confirmText={confirmText || <Msg m={commonCTAs.confirm} />}
          confirmDisabled={confirmDisabled}
          showCancel={showCancel}
          cancelText={cancelText || <Msg m={commonCTAs.cancel} />}
          onCancel={onCancel || onRequestClose}
          hint={footerHint}
        />
      )
    }
    {...props}
  >
    {children}
  </ModalOverlay>
);

ConfirmationDialog.defaultProps = {
  showCancel: true,
  danger: false,
};

const Footer = ({
  onConfirm,
  onCancel,
  confirmText,
  showCancel,
  cancelText,
  confirmPending,
  confirmDisabled,
  danger,
  hint,
}) => (
  <div
    style={{
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
    }}
  >
    {hint && <div>{hint}</div>}
    {/* IE11 prefers this over "marginRight: auto" in the hint div */}
    {hint && <div style={{ flexGrow: 1 }} />}
    {showCancel && (
      <a style={{ margin: "0 30px 0 0", fontWeight: 500 }} onClick={onCancel}>
        {cancelText}
      </a>
    )}
    <CTA
      primary
      inline
      danger={danger}
      style={{ margin: "0 0" }}
      disabled={!!confirmPending || confirmDisabled}
      onClick={confirmPending ? null : onConfirm}
    >
      {confirmPending && <CircleSpinner size={14} />} {confirmText}
    </CTA>
  </div>
);
